import React, { useState } from "react";

import { createStyles, makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CancelIcon from "@material-ui/icons/Cancel";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import SaveIcon from "@material-ui/icons/Save";

const useStyles = makeStyles((theme) =>
    createStyles({
        card: {
            marginBottom: theme.spacing(3),
            position: "relative",
        },
        edited: {
            color: theme.palette.primary.main,
        },
        commentText: {
            whiteSpace: "pre-wrap",
        },
    })
);

export default function ViewEditComment(props) {
    const [editingComment, setEditingComment] = useState(false);
    const [commentText, setCommentText] = useState(props.text);
    const [commentLengthError, setCommentLengthError] = useState(false);
    const classes = useStyles();

    const updateCommentText = (event) => {
        setCommentText(event.target.value);
        setCommentLengthError(event.target.value.length < 20 ? true : false);
    };

    const cancelEditingComment = () => {
        setEditingComment(false);
        setCommentText(props.text);
        setCommentLengthError(false);
    };

    return (
        <Card className={classes.card} key={props.id}>
            <CardContent>
                {!editingComment ? (
                    <React.Fragment>
                        <Typography
                            variant="body1"
                            component="pre"
                            className={classes.commentText}
                        >
                            {props.text}
                        </Typography>
                        <Typography variant="caption">
                            Added {props.formatted_date.created} ago
                            {props.last_modified ? (
                                <span className={classes.edited}>
                                    {" "}
                                    - Edited
                                </span>
                            ) : null}
                        </Typography>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <TextField
                            id="filled-textarea"
                            label="Comment"
                            multiline
                            rows={4}
                            placeholder="Enter your comment here."
                            variant="filled"
                            style={{ width: "100%" }}
                            value={commentText}
                            onChange={updateCommentText}
                            InputProps={{ autoFocus: true }}
                        />
                        {commentLengthError ? (
                            <Typography
                                variant="subtitle2"
                                component="p"
                                gutterBottom
                                color="error"
                            >
                                Minimum comment length is 20 characters
                            </Typography>
                        ) : null}
                    </React.Fragment>
                )}
            </CardContent>
            <CardActions disableSpacing>
                {!editingComment ? (
                    <IconButton
                        aria-label="Edit"
                        onClick={() => setEditingComment(true)}
                    >
                        <EditIcon color="primary" titleAccess="Edit Comment" />
                    </IconButton>
                ) : (
                    <IconButton
                        aria-label="Save"
                        onClick={() => props.onSaveClick(props.id, commentText)}
                    >
                        <SaveIcon
                            color={commentLengthError ? "disabled" : "primary"}
                            titleAccess="Save Changes"
                        />
                    </IconButton>
                )}
                {!editingComment ? (
                    <IconButton
                        aria-label="Delete"
                        onClick={() => props.onDeleteClick(props.id)}
                    >
                        <DeleteIcon
                            color="primary"
                            titleAccess="Delete Comment"
                        />
                    </IconButton>
                ) : (
                    <IconButton
                        aria-label="Cancel"
                        onClick={() => cancelEditingComment()}
                    >
                        <CancelIcon
                            color="primary"
                            titleAccess="Cancel Editing"
                        />
                    </IconButton>
                )}
            </CardActions>
        </Card>
    );
}
